module.exports = __webpack_public_path__ + "img/es-box4-text-dark.f085c240.png";